module.exports = __webpack_public_path__ + "img/icon-monitoring.5de93de1.png";